<template>
	<div class="current-pools-page">
		<div class="current-pools-page__content">
			<h1 class="current-pools-page--header">Your Current Pools</h1>
			<div class="logged-in" v-if="authenticated">
				<div class="no-pools" v-if="currentPools == null">
					<p>You're not in any current pools.  <router-link class="no-pools__link" :to="{ name: 'create-pool' }">Create</router-link> or <router-link class="no-pools__link" :to="{ name: 'join-pool' }">Join</router-link> one today!</p>
				</div>

				<pool class="pool" v-for="pool in currentPools" :name="pool.name" :sport="pool.event" :userIsManager="pool.user_is_manager" :apiPath="pool.api_path" :id="pool.id" :key="pool.event.concat(pool.id)"></pool>
			</div>
			<div class="logged-out" v-else>
				<button class="auth-button auth-button--primary" @click="SET_LOGIN_REGISTER(true)">Please Login or Signup!</button>
			</div>

			<router-link class="floating-action-button" :to="{ name: 'create-pool' }">
				<i class="material-icons">add</i>
			</router-link>
		</div>
	</div>
</template>

<script>
	import { mapGetters, mapMutations } from 'vuex'
	import PoolListItem from '../components/PoolListItem'
	
	export default {
		components: {
			'pool': PoolListItem
		},
		computed: {
			...mapGetters([
				'currentPools',
				'authenticated'
			])
		},
		methods: {
			...mapMutations([
				'SET_LOGIN_REGISTER'
			]),
		}
	}
</script>

<style lang="scss">
	@import '../styles/app';
	@import '../styles/views/currentPools';
</style>